<rt-box variant="vertical no-padding">
  <div class="section header" layout layout-align-items-center layout-space-between>
    <div class="header-info" layout layout-align-items-center>
      <rt-avatar
        [type]="
          evaluation().reviewer.hasAvatar || !evaluation().reviewer.initials ? 'image' : 'initials'
        "
        size="medium"
        [imageSrc]="evaluation().reviewer.photoThumbUrl"
        [initials]="evaluation().reviewer.initials"
        iconName="person"
        context="admin"
      />

      <div layout layout-vertical>
        <div class="name-row" layout layout-align-items-center>
          <span class="admin-name">{{ evaluation().reviewer.name }}</span>

          @for (badge of roleBadges(); track badge) {
            <rt-badge color="secondary" [text]="badge | translate" margin-left-small-x />
          }
        </div>
        <span class="edited-at">
          {{
            'app.evaluation_tab.form_details.reviewer_result.added'
              | translate: { time: (evaluation().createdAt | rtTimeAgo) }
          }}
          @if (isEdited()) {
            <span class="edited-at-divider">&bull;</span>
            {{
              'app.evaluation_tab.form_details.reviewer_result.edited'
                | translate: { time: (evaluation().updatedAt | rtTimeAgo) }
            }}
          }
        </span>
      </div>
    </div>

    @if (evaluation().canEdit || evaluation().canDelete) {
      <div class="header-actions" layout layout-align-items-center>
        @if (evaluation().canEdit) {
          <rt-icon-button
            variant="plain"
            iconName="edit"
            shape="square"
            (click)="edit.emit(evaluation())"
          />
        }

        @if (evaluation().canDelete) {
          <rt-icon-button
            variant="plain"
            iconName="delete"
            shape="square"
            class="danger-on-hover"
            (click)="delete.emit(evaluation())"
          />
        }
      </div>
    }
  </div>

  @if (isPreviewOpen()) {
    <rt-divider variant="line" [hasNoMargin]="true" />
    <div class="section preview">
      <rt-candidate-offer-evaluation-reviewer-result-preview
        [answers]="evaluation().answers"
        [score]="evaluation().score"
        [ratingScale]="evaluation().ratingScale"
        [ratingNote]="evaluation().ratingNote"
        [showScoreIcon]="showScoreIcon()"
        [useProsemirror]="useProsemirror()"
      />
    </div>
  }

  <rt-divider variant="line" [hasNoMargin]="true" />
  <div class="section footer" layout layout-align-items-center layout-space-between>
    <div class="footer-info" layout layout-align-items-center>
      @if (evaluation().ratingScale; as scale) {
        @if (evaluation().score) {
          <span class="label">
            {{ 'app.evaluation_tab.form_details.reviewer_result.score' | translate }}:
          </span>

          <rt-evaluation-rating-score
            [evaluationScale]="scale"
            [score]="evaluation().score"
            [showIcon]="showScoreIcon()"
            iconSize="small"
            fontSize="default"
          />
        }
      }

      @if (evaluation().skillsCount) {
        @if (evaluation().score) {
          <span class="footer-divider"></span>
        }

        <span class="label">
          {{ 'app.evaluation_tab.form_details.reviewer_result.skills' | translate }}:
        </span>
        <rt-icon name="skills" size="small" />
        <span class="skills-count">
          {{ evaluation().matchingSkillsCount }}/{{ evaluation().skillsCount }}
        </span>
      }
    </div>

    <rt-button variant="tertiary" (click)="togglePreview()">
      {{ 'app.evaluation_tab.form_details.reviewer_result.view_evaluation' | translate }}
      <rt-icon name="arrow-drop-down" size="small" class="chevron" [class.open]="isPreviewOpen()" />
    </rt-button>
  </div>
</rt-box>
